<h2 mat-dialog-title>{{ 'genericTree.dialog.assignMetadataTo' | transloco:{ name: data.node.name } }}</h2>

<mat-dialog-content>

  @if (consumer()) {
  <div class="metadata-form-container full-height">
    <!-- <pixl-learnitem-metadata
      [formGroup]="form"
      [consumer]="$any(consumer())"
      [learnItem]="data.node"
      [customMetadata]="adaptedActiveMetadata()"
      [mode]="mode">
    </pixl-learnitem-metadata> -->
  </div>
  } @else {
    <p>{{ 'genericTree.error.consumerNotFound' | transloco }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'genericTree.action.cancel' | transloco }}</button>
  <button mat-raised-button color="primary" (click)="onSave()">{{ 'genericTree.action.save' | transloco }}</button>
</mat-dialog-actions>
